import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { verifyAccountDispatch } from '../../reducers/UserReducer';
function useQuery() {
	const { search } = useLocation();

	return React.useMemo(() => new URLSearchParams(search), [search]);
}
const AccountVerify = () => {
	let query = useQuery();
	const dispatch = useDispatch();
	const { loadinguser } = useSelector((state) => state.user);
	console.log(query.get('validationString'));
	useEffect(() => {
		if (query.get('validationString')) {
			let formData = {
				validationString: query.get('validationString'),
			};
			dispatch(verifyAccountDispatch(formData));
		}
	}, []);
	return (
		<>{loadinguser ? <div>please wait.....</div> : <div>AccountVerify</div>}</>
	);
};

export default AccountVerify;
